import React from "react";
import { TranscriptLine } from "@/pages/InterviewTranscript";

export const PlayerInterview = ({ interview }) => (
  <section data-testid="player-step-interview">
    <p className="text-[11px] uppercase tracking-[0.18em] text-slate-500">
      {interview.covered}/{interview.total} preguntas cubiertas · {interview.structure.departments} departamentos ·{" "}
      {interview.structure.people} cargos · {interview.structure.activities} actividades
    </p>
    <ol className="mt-6 space-y-5">
      {interview.messages.map((m, i) => (
        <TranscriptLine key={`m-${i}`} m={m} />
      ))}
    </ol>
  </section>
);
